import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type { BackendBrandVoice, BackendMutationCreateBrandVoiceArgs } from 'src/types/backend';

import { FRAGMENT_BRAND_VOICE, FRAGMENT_BRAND_VOICE_ASSETS } from './schema';

const MUTATION = gql`
  mutation CreateBrandVoice($name: String!, $customerId: ID!, $workspaceId: ID, $language: String) {
    createBrandVoice(
      name: $name
      customerId: $customerId
      workspaceId: $workspaceId
      language: $language
    ) {
      ...BrandVoice
      ...BrandVoiceAssets
    }
  }
  ${FRAGMENT_BRAND_VOICE}
  ${FRAGMENT_BRAND_VOICE_ASSETS}
`;

type Variables = BackendMutationCreateBrandVoiceArgs;
type Result = BackendBrandVoice;

export const createBrandVoice = async (variables: Variables) => {
  const result = await executeGqlMutation({
    mutation: MUTATION,
    variables,
  });

  return getSingleProp<Result>(result.data);
};
